import React, {useMemo} from 'react';
import {useDispatch} from "react-redux";
import ColumnFilter from "../../ColumnFilter";
import styles from "../../ArticlesTable.module.scss";
// @ts-ignore
import {useFilters, useSortBy, useTable} from "react-table";
import {changeArticleVisibilityValue} from "../../../../store/admin-cms-actions";

type Props = {
    articlesData: [],
    branchMarketplaceId: number
}

const ArticleTableForBranchMarketplace = ({articlesData, branchMarketplaceId}: Props) => {

    const dispatch = useDispatch();

    const data = useMemo(() => {

        return articlesData.map((article: any) => {

            const changeVisibility = (e: any) => {
                dispatch<any>(changeArticleVisibilityValue([{
                    branchMarketplaceId: +branchMarketplaceId,
                    itemId: article.itemResponse.id,
                    apotekaRs: e.target.checked
                }]))
            }
            return (
                {
                    col1: article.itemResponse.id,
                    col2: article.itemResponse.name,
                    col3: article.itemResponse.manufacturerName,
                    col4: <input type="checkbox" defaultChecked={article.apotekaRs} onChange={e => changeVisibility(e)}
                                 style={{backgroundColor: "red"}}/>,
                    col5: article.apotekaRs ? 'apoteka.rs' : 'skriveno'
                }
            )
        })
    },[articlesData])

    const columns = React.useMemo(
        () => [
            {
                Header: 'id',
                accessor: 'col1', // accessor is the "key" in the data
                Filter: ColumnFilter
            },
            {
                Header: 'Naziv artikla',
                accessor: 'col2',
                Filter: ColumnFilter
            },
            {
                Header: 'Proizvođač',
                accessor: 'col3',
                Filter: ColumnFilter
            },
            {
                Header: "Promeni vidljivost na apoteka.rs",
                accessor: 'col4',
                Filter: false
            },
            {
                Header: "Vidljivost",
                accessor: 'col5',
                Filter: ColumnFilter
            },
        ],
        []
    )

    const tableInstance = useTable({columns, data}, useFilters, useSortBy)

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow
    } = tableInstance

    return (
        // apply the table props
        <table {...getTableProps()} style={{border: 'solid 1px blue'}}>
            <thead>
            {headerGroups.map((headerGroup: any) => (
                <tr {...headerGroup.getHeaderGroupProps()}>
                    {headerGroup.headers.map((column: any) => (
                        <th {...column.getHeaderProps(column.getSortByToggleProps())}>
                            <div style={{display:"flex", justifyContent:"center"}}>{column.render('Header')}
                                <span>
                        {column.isSorted
                            ? (column.isSortedDesc
                                ? ' ▼'
                                : ' ▲')
                            : ''}
                        </span>
                            </div>
                            <div>{column.canFilter ? column.render('Filter') : null}</div>

                        </th>
                    ))}
                </tr>
            ))}
            </thead>
            <tbody {...getTableBodyProps()}>
            {rows.map((row: any) => {
                prepareRow(row)
                return (
                    <tr {...row.getRowProps()} className={styles.Tr}>
                        {row.cells.map((cell: any) => {
                            return (
                                <td
                                    {...cell.getCellProps()}
                                >
                                    {cell.render('Cell')}
                                </td>
                            )
                        })}
                    </tr>
                )
            })}
            </tbody>
        </table>
    );
};

export default ArticleTableForBranchMarketplace;